import Circle from "./Circle";
import {Fragment} from "react";
import Pillar from "./Pillar";
import EventCard from "./EventCard";
import {Grid} from "@mui/material";



function Timeline() {

    const events = [
        {
            heading: "2006",
            subHeading: "Company founded by PD Dr. Thomas Häupl and colleagues as a spin-off of Charité - Universitätsmedizin Berlin \n" +
                "Rainer Seubert as Consultant\n" +
                "Cooperation with Charité-Universitätsmedizin Berlin and Deutsches Rheuma Forschungszentrum for analysis of Affymetrix transcriptome data (bioinformatics)",
            deriction: "right"
        },
        {
            heading: "2010",
            subHeading: "AI ImmunoClust software development in the Charité Research Group for user independent clustering of cytometry data from clinical research by members of our team \n" +
                "Testing and adapting to the heterogeneity of cytometry data \n" +
                "Development of strategies for automated cluster characterization (cell type identification) for application in Rheumatology",
            deriction: "left"
        },
        {
            heading: "2016-2017",
            subHeading: "Development of adaptations for an early Cancer Screening Tests based on the AI tool immunoClust\n" +
                "Appointment Rainer Seubert as CEO\n" +
                "Long-term agreement signed with leading developer and marketing company of an early Cancer Screening Test\n" +
                "Development of an automated immunoClust AI-analysis pipeline for the cytometry based Cancer Screening Test",
            deriction: "right"
        },
        {
            heading: "2018 to date",
            subHeading: "Analysis of cytometry data for the Cancer Screening Test in clinical studies worldwide",
            deriction: "left"
        },
        {
            heading: "2020",
            subHeading: "Team Charité moves to spin off company BioRetis from Charité Universitätsmedizin Berlin\n" +
                "Certification (CE) of cytometry based Cancer Screening Test by project partner company",
            deriction: "right"
        },
        {
            heading: "2022",
            subHeading: "New shareholder structure -  PD Dr. Häupl and Team",
            deriction: "left"
        },
        {
            heading: "2022 to date",
            subHeading: "Analysis of the worldwide marketed Cancer Screening Test,  refinement of the iCAP tool, iCAP software adaptation for use on cloud servers for scalability, multi-user availability and flexibility for individual immune screening concepts\n" +
                "Certification (CE) for new cytometry tests",
            deriction: "right"
        },
    ]


    return <>
        <div className={"flexContainer"}>
            <Circle/>
            {events.map((event, index) => {
                    return <Fragment key={index}>
                        <div className={"gridContainer"}>
                            {
                                event.deriction === "left" ? (
                                    <Grid >
                                        <EventCard heading={event.heading} subHeading={event.subHeading}/>
                                    </Grid>
                                ) : (<div className={"gap"}></div>)
                            }
                            <Pillar/>
                            {
                                event.deriction === "right" ? (
                                    <Grid >
                                        <EventCard heading={event.heading} subHeading={event.subHeading}/>
                                    </Grid>
                                ) : (<div className={"gap"}></div>)
                            }
                            <div className={"gap"}></div>
                            <Circle/>
                        </div>
                    </Fragment>
                }
            )}
        </div>

    </>

}

export default Timeline